import { BASE_URL, STRIPE_API } from './constants';
import request from './request';

// Create customer with stripe id
async function getStripeID(name, email) {
  return await request(`${STRIPE_API}/customerCreate.php?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`, {
    method: 'POST'
  });
}

export async function customerStripeID(name, email) {
  let result = await getStripeID(name, email);
  return result.value;
}

// Register a new user
export async function registerUser(name, email, password, stripeId, newsletter, firstname, lastname, company, terms) {
  const headers = new Headers({
    'Content-Type': 'application/json'
  });

  const body = JSON.stringify({
    name: [{ value: name }],
    mail: [{ value: email }],
    pass: [{ value: password }],
    stripe_customer_id: [{ value: stripeId }],
    field_newsletter: [{ value: newsletter }],
    field_name_first: [{ value: firstname }],
    field_name_last: [{ value: lastname }],
    field_company_name: [{ value: company }],
    field_terms: [{ value: terms }]
  });

  const requestOptions = {
    method: 'POST',
    headers,
    body,
    redirect: 'follow'
  };

  return await request(
    `${BASE_URL}/user/register?_format=json`,
    requestOptions
  );
}

//Login an existing user
export async function loginUser(username, password) {
  const headers = new Headers({
    'Content-Type': 'text/plain'
  });
  const body = JSON.stringify({
    name: username,
    pass: password 
  });

  const requestOptions = {
    method: 'POST',
    headers,
    body,
    redirect: 'follow'
  };

  return await request(`${BASE_URL}/user/login?_format=json`, requestOptions);
}

//Update an existing user profile
export async function updateProfile(
        uuid,
        username,
        newsletter,
        firstname,
        lastname,
        company,
        user){

  const headers = new Headers({
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
    'X-CSRF-Token': user.csrf_token,
    Authorization: `Bearer ${user.access_token}`,
  });
  const body = JSON.stringify({
   "data": {
      "type": 'user--user',
      "id": uuid,
      "attributes": {
        "name": username,
        // "field_newsletter": Boolean(newsletter),
        "field_name_first": firstname,
        "field_name_last": lastname,
        "field_company_name": company,
        // "field_user_mailchimp": Boolean(newsletter)

      },
    },

  });

  const requestOptions = {
    method: 'PATCH',
    headers,
    body,
  };

  return await request(`${BASE_URL}/api/user/` + uuid, requestOptions);
}


// Reset user password and send e-mail with temp
export async function resetUser(email) {
  const headers = new Headers({
    'Content-Type': 'application/json'
  });
  const body = JSON.stringify({
    mail: email,
  });

var requestOptions = {
  method: 'POST',
  headers: headers,
  body,
  redirect: 'follow'
};

  return await request(`${BASE_URL}/user/lost-password?_format=json`, requestOptions);
}

// Update user password with new one using temp password from e-mail
export async function updatePass(name, temp, pass, setUser) {
  const headers = new Headers({
    'Content-Type': 'application/json'
  });
  const body = JSON.stringify({
    name: name,
    temp_pass: temp,
    new_pass: pass,
  });

var requestOptions = {
  method: 'POST',
  headers: headers,
  body,
  redirect: 'follow'
};

  const result = await request(`${BASE_URL}/user/lost-password-reset?_format=json`, requestOptions);
  const user = await loginUser(name, pass);
  const userInfo = await getUserInfo(user);
  setUser({
        ...user,
        ...userInfo[0],
      });
  return result;
}

/**
 * Check if the current user is logged in.
 * If user is logged in, they will have a cookie that will automatically
 * get sent with this request
 * @returns {0 | 1} logged in status (0 no | 1 yes)
 */
export async function getLoginStatus(user) {
  const headers = new Headers({
    'X-CSRF-Token': user.csrf_token,
    Authorization: `Bearer ${user.access_token}`
  });
  const requestOptions = {
    method: 'GET',
    headers,
    redirect: 'follow'
  };

  return await request(
    `${BASE_URL}/user/login_status?_format=json`,
    requestOptions
  );
}

/**
 * Get logged in user info
 * @param {object} user The logged in user
 * @returns {object} user information
 */
export async function getUserInfo(user) {
  const headers = new Headers({
    'X-CSRF-Token': user.csrf_token,
    Authorization: `Bearer ${user.access_token}`
  });
  const requestOptions = {
    method: 'GET',
    headers,
    redirect: 'follow'
  };

  return await request(`${BASE_URL}/user/me?_format=json`, requestOptions);
}

/**
 * log out the current user
 * @param {string} token
 */
export async function logoutUser(user) {
  const headers = new Headers({
    'content-type': 'application/json',
    'X-CSRF-Token': user.csrf_token
  });
  const requestOptions = {
    method: 'GET',
    headers
  };
  return await request(
    `${BASE_URL}/user/logout?_format=json&token=${user.logout_token}`,
    requestOptions
  );
}

/**
 * get number of downloads available to the user
 * @param {Integer} userId logged in user's uuid
 */
export async function getCredits(userId) {
  const headers = new Headers();
  const requestOptions = {
    method: 'GET',
    headers,
    redirect: 'follow'
  };

  const result = await request(
    `${BASE_URL}/api/user/${userId}`,
    requestOptions
  );
  console.log('Credits:' + result.data.attributes.field_user_credits);
  return result;
}

  // Get a list of users maps
//https://api.cartocuts.com/api/maps?_format=json

export async function getMaps(user) {

    var GetMapsHeaders = new Headers();
    GetMapsHeaders.append("Content-Type", "application/vnd.api+json");
    GetMapsHeaders.append("Accept", "application/vnd.api+json");
    GetMapsHeaders.append("Authorization", `Bearer ${user.access_token}`);

    var GetMapOptions = {
      method: 'GET',
      headers: GetMapsHeaders,
      redirect: 'follow',
    };

    const maps = fetch(`${BASE_URL}/api/maps?_format=json`, GetMapOptions)
      .then(response => response.json())
      .then(result => result)

      return maps
  }

